import create from 'zustand';

interface IDuplicateImagesStoreVariables {
  primaryImageId: number | null;
  checkedImageIds: Set<number>;
}

interface IDuplicateImagesStore extends IDuplicateImagesStoreVariables {
  isPrimaryImage: (imageId: number) => boolean;
  setPrimaryImage: (imageId: number) => void;
  isImageChecked: (imageId: number) => boolean;
  populateCheckedImages: (imageIds: number[]) => void;
  reset: () => void;
  resetCheckedImages: () => void;
  toggleImageChecked: (imageId: number) => void;
}

const useDuplicateImagesStore = create<IDuplicateImagesStore>((set, get) => ({
  checkedImageIds: new Set(),
  isImageChecked: (imageId) => {
    const state = get();
    return state.checkedImageIds.has(imageId);
  },
  isPrimaryImage: (imageId) => {
    const state = get();
    return state.primaryImageId === imageId;
  },
  populateCheckedImages: (imageIds) => {
    const { checkedImageIds } = get();
    const newCheckedImageIds = new Set(checkedImageIds);

    imageIds.forEach(id => newCheckedImageIds.add(id));

    return set({ checkedImageIds: newCheckedImageIds });
  },
  primaryImageId: null,
  reset: () => set({
    checkedImageIds: new Set(),
    primaryImageId: null,
  }),
  resetCheckedImages: () => {
    const { primaryImageId } = get();

    return set({ checkedImageIds: new Set([primaryImageId]) });
  },
  setPrimaryImage: (imageId) => {
    const state = get();
    const newCheckedIds = new Set(state.checkedImageIds);
    newCheckedIds.add(imageId);

    set({ checkedImageIds: newCheckedIds, primaryImageId: imageId });
  },
  toggleImageChecked: (imageId) => {
    const { checkedImageIds, primaryImageId } = get();
    const newCheckedIds = new Set(checkedImageIds);

    if (newCheckedIds.has(imageId) && imageId !== primaryImageId) {
      newCheckedIds.delete(imageId);
    } else {
      newCheckedIds.add(imageId);
    }

    set({ checkedImageIds: newCheckedIds });
  },
}));

export default useDuplicateImagesStore;
